module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Karang-Nini-4973eb1fa898dfb43cd7b8525ca9e616.jpg";